import axiosInstance from './axiosInstance';

export const getNotifications = (page, pageSize, type) => {
  return axiosInstance
    .get(
      `/andrology/notifications?page=${page}&pageSize=${pageSize}&type=${type}`,
    )
    .then((response) => response)
    .catch((error) => {
      console.error('Error fetching notifications:', error);
      throw error;
    });
};

export const sendNotification = (patientId, sfrId, type) => {
  return axiosInstance
    .post('/andrology/notifications/send-notification', {
      patientId,
      sfrId,
      type,
    })
    .then((response) => response)
    .catch((error) => {
      console.error('Error sending notification:', error);
      throw error;
    });
};

export const deleteNotification = async (patientId, sfrId, type, comments) => {
  return axiosInstance
    .post('/andrology/notifications/delete', {
      patientId,
      sfrId,
      type,
      comments,
    })
    .then((response) => response)
    .catch((error) => {
      console.error('Error deleting notifications:', error);
      throw error;
    });
};

export const getNotificationDays = () => {
  return axiosInstance
    .get('/andrology/notifications/notification-days')
    .then((response) => response)
    .catch((error) => {
      console.error('Error fetching notification days:', error);
      throw error;
    });
};

export const updateNotificationDays = (sfrExpiryDays) => {
  return axiosInstance
    .post('/andrology/notifications/notification-days', {
      sfrExpiryDays,
    })
    .then((response) => response)
    .catch((error) => {
      console.error('Error updating notification days:', error);
      throw error;
    });
};
